export default class FilterTreeCtrl {
  constructor($scope, $attrs, Trees, FactQuery) {
    this.filterIndex = $scope.$index;
    this.factQuery = FactQuery;
    this.trees = Trees;
    this.filter = $scope.$eval($attrs.lfFilter);
    this.parent = $scope.$eval($attrs.lfParent);

    // Get the tree if not already fetched
    if (this.trees[this.filter.attribute].data.length === 0) {
      this.trees[this.filter.attribute].api.get();
    }
    this.allExcluded = this.getAllExcluded();
    this.allCollapsed = this.getAllCollapsed();
  }

  toggleCollapsed(node, event) {
    event.stopImmediatePropagation();
    event.preventDefault()
    this.trees[this.filter.attribute].toggleCollapsed(node);
    this.filter = this.trees[this.filter.attribute].findAllCollapsed(this.filter);
    this.factQuery.data.filterPipeline[this.filterIndex] = this.filter;
    this.allCollapsed = this.getAllCollapsed();
    this.factQuery.api.update();
  }
  getAllCollapsed() {
    return this.filter.collapsed && this.filter.collapsed.length === 0 ? this
      .filter.uncollapsed === null ? false : true : undefined;
  }
  setAllCollapsed(collapsed) {
    this.trees[this.filter.attribute].setAllCollapsed(collapsed);
    this.filter.uncollapsed = collapsed ? [] : null;
    this.filter.collapsed = [];
    this.factQuery.data.filterPipeline[this.filterIndex] = this.filter;
    this.allCollapsed = this.getAllCollapsed();
    this.factQuery.api.update();
  }

  toggleExcluded(node) {
    this.trees[this.filter.attribute].toggleExcluded(node);
    this.filter = this.trees[this.filter.attribute].findAllExcluded(this.filter);
    this.factQuery.data.filterPipeline[this.filterIndex] = this.filter;
    this.allExcluded = this.getAllExcluded();
    this.factQuery.api.update();
  }

  getAllExcluded() {
    return this.filter.excludes && this.filter.excludes.length === 0 ? this.filter
      .includes === null ? false : true : undefined;
  }

  setAllExcluded() {
    let excluded = !this.allExcluded;
    this.trees[this.filter.attribute].setAllExcluded(excluded);
    this.filter.includes = excluded ? [] : null;
    this.filter.excludes = [];
    this.factQuery.data.filterPipeline[this.filterIndex] = this.filter;
    this.allExcluded = this.getAllExcluded();
    this.factQuery.api.update();
  }

  setViewBy(key) {
    this.filter = {
      attribute: key
    };
    this.factQuery.data.filterPipeline[this.filterIndex] = this.filter;
    this.factQuery.api.update();
  }
  setSorting(direction) {
    if (this.filter.sort === direction) {
      this.filter.sort = null;
    } else {
      this.filter.sort = direction;
    }
    this.factQuery.data.filterPipeline[this.filterIndex] = this.filter;
    this.factQuery.api.update();
  }
}

FilterTreeCtrl.$inject = [
  '$scope', '$attrs', 'Trees', 'FactQuery'
];



// WEBPACK FOOTER //
// ./project/directives/lf-filter-tree/filter-tree.controller.js